const CREATOR_STORE_LS_KEY = `code`;

export { CREATOR_STORE_LS_KEY };
